import * as Yup from "yup";
import type { OnboardingCaseType } from "../types";

export type CaseInfoFormValues = {
  clientId?: string;
  clientName?: string;
  entityId?: string;
  entityName?: string;
  isUnlinked: boolean;
  programName: string;
  programId?: number;
  assignToMyself: boolean;
};

const parentIsUnlinked = (parent: unknown): boolean => {
  if (typeof parent !== "object" || parent === null) return false;
  if (!("isUnlinked" in parent)) return false;
  return Boolean(parent.isUnlinked);
};

export const createCaseInfoSchema = (
  caseType: OnboardingCaseType,
): Yup.ObjectSchema<CaseInfoFormValues> =>
  Yup.object({
    clientId: Yup.string()
      .optional()
      .test("client-required", "Client is required", function (value) {
        if (caseType === "entity") return Boolean(value);
        return Boolean(value) || parentIsUnlinked(this.parent);
      }),
    clientName: Yup.string().default(""),
    entityId: Yup.string()
      .optional()
      .test("entity-required", "Entity is required", function (value) {
        if (caseType !== "entity") return true;
        return Boolean(value) || parentIsUnlinked(this.parent);
      }),
    entityName: Yup.string().default(""),
    isUnlinked: Yup.boolean().required().default(false),
    programName: Yup.string()
      .default("")
      .when("isUnlinked", {
        is: true,
        then: (schema) => schema.required("Compliance program is required"),
        otherwise: (schema) => schema,
      }),
    programId: Yup.number().optional(),
    assignToMyself: Yup.boolean().required().default(false),
  });
